import React, { useEffect, useState } from "react"
import { Box, TextField, MenuItem, Button, Grid, Typography, Paper, useMediaQuery } from "@mui/material"
import { useTheme } from "@emotion/react"
import { styled } from "@mui/system"
import { useQuery } from "@tanstack/react-query"
import fetchwrapper from "../../../services/interceptors/fetchwrapper"
import CustomBackdrop from "../../../components/CustomBackdrop"
import { Modal } from "react-bootstrap"

const Section = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  marginBottom: theme.spacing(4),
  position: "relative",
  border: "1px solid #0072B1",
}))

const SectionTitle = styled(Typography)(({ theme }) => ({
  position: "absolute",
  top: "-0.75em",
  left: "1em",
  backgroundColor: theme.palette.background.paper,
  // padding: `0 ${theme.spacing(2)}px`,
  padding: "0 16px",
}))

const FlexRow = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(2),
  flexDirection: "column", // Default to column
  [theme.breakpoints.up("md")]: {
    flexDirection: "row", // Change to row on medium screens and up
  },
}))

const tipoIdentificacionOptions = [
  { value: "C", label: "Cédula" },
  { value: "R", label: "RUC" },
  { value: "P", label: "Pasaporte" },
]
const tipoSectorOptions = [
  { value: "000", label: "SIN SECTOR" },
  { value: "MIX", label: "MIXTO PRIV Y PUB" },
  { value: "PRIV", label: "PRIVADO" },
  { value: "PUB", label: "PUBLICO" },
]
const tipoIntegradorOptions = [
  { value: "I", label: "INTEGRADOR" },
  { value: "U", label: "USUARIO FINAL" },
]

const ModalCreateIntegrador = ({ handleCloseModalCreateIntegrador, cabeceraProforma, setCabeceraProforma }) => {
  const [isLoadingCreatingIntegrador, setIsLoadingCreatingIntegrador] = useState(false)
  const [formData, setFormData] = useState({
    codigo: "", // Codigo integrador
    tipoIdentificacion: "",
    nIdentificacion: "",
    nombre: "",
    direccion: "",
    telefono: "",
    tipo: "",
    sector: "",

    // ruc: "",
    // razonSocial: "",
  })
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
  }

  const resetModalCliente = async () => {
    setFormData((prev) => ({
      ...prev,
      codigo: "",
      tipoIdentificacion: "",
      nIdentificacion: "",
      nombre: "",
      direccion: "",
      telefono: "",
      tipo: "",
      sector: "",
      // ruc: "",
      // razonSocial: "",
    }))
  }

  // -------------------------------------------
  //               QUERYS
  // -------------------------------------------

  const handleSubmit = async (e) => {
    const { codigo, tipoIdentificacion, nIdentificacion, nombre, direccion, telefono, tipo, sector } = formData

    // -----VERIFICACIONES-----
    const regexExpression = /^[0-9]+$/

    if (!regexExpression.test(nIdentificacion)) return alert("El número de identificacion no es válido")

    if (!nIdentificacion || !tipoIdentificacion) return alert("Complete los campos de identificación")

    if (tipoIdentificacion === "C" && nIdentificacion.length !== 10)
      return alert("Digite correctamente el número de cédula")
    if (tipoIdentificacion === "R" && nIdentificacion.length !== 13) return alert("Digite correctamente el ruc")

    // -----SAVE CLIENTE-----

    try {
      setIsLoadingCreatingIntegrador(true)
      // Aquí se envia los datos del cliente al backend para procesarlos
      const request = {
        integracodigo: codigo,
        integradescri: nombre,
        integraidentifica: tipoIdentificacion,
        integraruc: nIdentificacion,
        integrastatus: "A",
        integradirecc: direccion,
        integrafono: telefono,
        integratipo: tipo,
        sectorcodigo: sector,
      }
      const options = {
        method: "POST",
        body: JSON.stringify(request),
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      }
      let result = await fetchwrapper("/facturacion_proformas/create_integrador", options)
      result = await result.json()

      setCabeceraProforma({
        ...cabeceraProforma,
        integradescro: nombre,
        integracodigo: result.integracodigo,
      })

      alert("Integrador procesado correctamente")

      // Limpia el formulario después de enviar los datos
      //   clearModalCreateClient();
      setFormData({})

      // Cerrar el modal
      handleCloseModalCreateIntegrador()
    } catch (err) {
      console.log(err.msg)
      alert("No se pudo crear el integrador")
    } finally {
      setIsLoadingCreatingIntegrador(false)
    }

    console.log(formData, tipoIdentificacion)
  }

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
  return (
    <>
      <CustomBackdrop isLoading={isLoadingCreatingIntegrador} zIndex={1000000} />
      <Box
        sx={{
          p: 2,
          maxHeight: isMobile ? "90vh" : "auto", // Limit height on mobile
          overflowY: isMobile ? "auto" : "visible", // Enable scrolling on mobile
        }}
      >
        <Section elevation={3}>
          <SectionTitle variant="h6">Datos Generales</SectionTitle>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FlexRow>
                <TextField
                  label="Código"
                  name="codigo"
                  value={formData.codigo}
                  fullWidth
                  variant="outlined"
                  onChange={handleChange}
                  inputProps={{ maxLength: 3 }}
                />
                <TextField
                  select
                  label="Tipo de Identificación"
                  name="tipoIdentificacion"
                  value={formData.tipoIdentificacion}
                  onChange={handleChange}
                  fullWidth
                  variant="outlined"
                >
                  {tipoIdentificacionOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  label="Número de Identificación"
                  name="nIdentificacion"
                  value={formData.nIdentificacion}
                  onChange={handleChange}
                  fullWidth
                  variant="outlined"
                  autoComplete="off"
                />
              </FlexRow>
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Nombre"
                name="nombre"
                value={formData.nombre}
                onChange={handleChange}
                fullWidth
                variant="outlined"
                autoComplete="off"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Dirección"
                name="direccion"
                value={formData.direccion}
                onChange={handleChange}
                fullWidth
                variant="outlined"
                autoComplete="off"
              />
            </Grid>
            <Grid item xs={12}>
              <FlexRow>
                <TextField
                  label="Teléfono "
                  name="telefono"
                  value={formData.telefono}
                  onChange={handleChange}
                  fullWidth
                  variant="outlined"
                  autoComplete="off"
                />
              </FlexRow>
            </Grid>
            <Grid item xs={12}>
              <FlexRow>
                <TextField
                  select
                  label="Sector"
                  name="sector"
                  value={formData.sectorcodigo}
                  onChange={handleChange}
                  fullWidth
                  variant="outlined"
                >
                  {tipoSectorOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  select
                  label="Tipo"
                  name="tipo"
                  value={formData.integratipo}
                  onChange={handleChange}
                  fullWidth
                  variant="outlined"
                >
                  {tipoIntegradorOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </FlexRow>
            </Grid>
          </Grid>
          <br />
          <br />

          {/* <Section elevation={3}>
            <SectionTitle variant="h6">Datos Matriz</SectionTitle>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="RUC"
                  name="nIdentificacion"
                  value={formData.nIdentificacion}
                  onChange={handleChange}
                  fullWidth
                  variant="outlined"
                  autoComplete="off"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Razón Social"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  fullWidth
                  variant="outlined"
                  autoComplete="off"
                />
              </Grid>
            </Grid>
          </Section> */}

          <Grid item xs={12}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              style={{ backgroundColor: "#114B5E", color: "white" }}
              fullWidth
              onClick={() => handleSubmit()}
            >
              Guardar
            </Button>
          </Grid>
        </Section>
      </Box>
    </>
  )
}

export default ModalCreateIntegrador
